import React, { useState } from 'react';
import PropTypes from 'prop-types';
import theme from 'styled-theming';
import styled from 'styled-components';
import { Flex } from 'rebass';

const textColor = theme('mode', {
  light: (props) => props.theme.colors.deepGrey,
  dark: (props) => props.theme.colors.white,
});

const titleTextColor = theme('mode', {
  light: (props) => props.theme.colors.dimGrey,
  dark: (props) => props.theme.colors.softMidGrey,
});

const borderColor = theme('mode', {
  light: (props) => props.theme.colors.midLightGrey,
  dark: (props) => props.theme.colors.midGhost,
});

const backgroundColor = theme.variants('mode', 'variant', {
  active: {
    dark: 'rgba(255, 255, 255, 0.1);',
    light: '#FFFFFF ;',
  },
  inactive: {
    dark: 'linear-gradient(180deg, rgba(88, 121, 218, 0.1) 0%, rgba(25, 25, 67, 0) 100%);',
    light: ' linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, #E6EBF5 100%);',
  },
  hover: {
    dark: 'linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.005) 100%, rgba(255, 255, 255, 0.005) 100%);',
    light: 'linear-gradient(180deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0) 100%);',
  },
});

const CardContent = styled.div`
  color: ${textColor}; 
  text-align: left;
  font-size: 14px;
  padding: 10%;
  line-height: 130%;
  overflow-wrap: break-word;
`;

const HoverContent = styled.div`
  color: ${textColor}; 
  text-align: left;
  font-size: 14px;
  padding-bottom: 4px;
  padding-top: 4px;
  padding-left: 10%; 
  overflow-wrap: break-word;
`;

const CardTitle = styled.div`
  font-size: 16px;
  color: ${textColor};
  text-align: left;
  padding-left: 10%; 
  padding-top: 30px;
  overflow-wrap: break-word; 
`;
const HoverTitle = styled(Flex)`
  color: ${titleTextColor};
  margin-top: 12px;
  font-size: 14px;
  padding-left: 10%; 
  padding-top: 12px; 
  padding-bottom: 12px;
  overflow-wrap: break-word; 
`;

const Container = styled.a`
  background: ${backgroundColor};
  border: 1px solid ${borderColor};
  max-width: 320px;
  max-height: 417px;
  min-width: 105px;    
  min-height: 215px;
  &:hover {
    width: 320px;
    max-height: 417px;
    min-height: 215px;    
  }
  flex: 0 1 320px;
  border-radius: 6px;  
  margin-right: ${(props) => (props.isMarginOff ? '0px' : '36px')};
  cursor: pointer; 
`;

function CardSde(props) {
  const {
    name, description, onClick, isHighlighted, sdeAttributeTypes, isMarginOff, ...otherProps
  } = props;
  const [isHover, setIsHover] = useState(false);

  function enableHover() {
    if (!isHighlighted) {
      setIsHover(true);
    } else {
      setIsHover(false);
    }
  }

  function disableHover() {
    setIsHover(false);
  }

  function getType() {
    if (isHover) {
      if (isHighlighted) {
        return 'active';
      }
      return 'hover';
    }
    return (isHighlighted ? 'active' : 'inactive');
  }
  return (
    <Container
      variant={getType()}
      isMarginOff={isMarginOff}
      onClick={onClick}
      minWidth={10}
      onMouseLeave={disableHover}
      onMouseOver={enableHover}
      onFocus={enableHover}
      {...otherProps}
    >
      <CardTitle>{name}</CardTitle>
      { (isHover === false) || isHighlighted === true ? (
        <CardContent>
          {description}
        </CardContent>
      )
        : (
          <div>
            <HoverTitle>
              TYPES OF ATTRIBUTES INCLUDED:
            </HoverTitle>
            {
            sdeAttributeTypes.map((attribute) => (
              <HoverContent key={attribute}>
                <li>{attribute}</li>
              </HoverContent>
            ))
            }
          </div>
        )}
    </Container>
  );
}

CardSde.defaultProps = {
  name: undefined,
};

CardSde.propTypes = {
  description: PropTypes.string.isRequired,
  name: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  isHighlighted: PropTypes.bool.isRequired,
  sdeAttributeTypes: PropTypes.array.isRequired,
  isMarginOff: PropTypes.bool.isRequired,
};

export default CardSde;
